module.exports = __webpack_public_path__ + "img/icon-sodam-map.b90a35fd.svg";